import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { WsPayResponseInput } from "../types/types";
const FINISH_PURCHASE_MUTATION = gql(`
  mutation FinishPurchase($offerId: String!, $input: WSPayResponseInput!) {
    setAsPaid(id: $offerId, input: $input)
  }
  `);

export function useFinishPurchase() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation(FINISH_PURCHASE_MUTATION);
  const finishPurchase = async (input?: WsPayResponseInput) => {
    if (!offerId) {
      return;
    }
    const { data } = await mutation({
      variables: { offerId, input },
    });
    return data;
  };
  return [finishPurchase, info] as const;
}
